import { render } from "./AdminPage.vue?vue&type=template&id=dd1d1b10&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"

import "./AdminPage.vue?vue&type=style&index=0&id=dd1d1b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1d1b10"]])

export default __exports__